<template>
  <div class="flex flex-col gap-3 p-5 text-center">
    <slot name="text" />

    <slot name="buttons" />
  </div>
</template>
